import React from 'react';

/**
 * Official full-colour Shade mark: an isometric stack of two slabs in four purples.
 * Paths and fills are app.shade.inc/images/logo.svg as served on 2026-10-06; the
 * fills are hard-coded rather than currentColor because the four shades are what
 * reads as depth.
 *
 * Only for surfaces that tint per platform (see ExternalLinkIcon). Anywhere the
 * icon sits in a row of muted platform glyphs — the supported-platforms line, the
 * media menu — use the monochrome ShadeIcon so it greys out with its neighbours.
 *
 * The artwork is portrait (1033 x 1188); width/height keep that aspect ratio for
 * `width: auto` callers.
 */
const ShadeColorIcon: React.FC = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1033 1188" width="16" height="18">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#863EFF"
        d="M0 891.927V718.052L516.143 1015.37V1187.3L0 891.927Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C37AFF"
        d="M1032.29 891.927V718.052L516.143 1015.37V1187.3L1032.29 891.927Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#C37AFF"
        d="M1032.29 471.19V297.314L516.143 594.63V766.56L1032.29 471.19Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4A30DD"
        d="M1032.28 718.051L516.143 1015.37L258.071 617.903L516.143 766.56L915.414 538.062L1032.28 718.051Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#863EFF"
        d="M516.143 1015.37L258.071 617.902L516.143 766.56V594.63L0 297.314V469.244L258.071 866.709L516.143 1015.37Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#AE4BFF"
        d="M0 297.315L516.143 594.63L1032.29 297.315L516.143 0L0 297.315Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#4A30DD"
        d="M0 718.051L117.577 650.328L258.071 866.709L0 718.051Z"
      />
    </svg>
  );
};

export default ShadeColorIcon;
